module.exports = __webpack_public_path__ + "static/bg4-1622a465b8dcc52f79e428b36d8f0938.png";